<template>
  <v-container data-test-id="emailTemplatesView" fluid>
    <!--
    <PrimarySelect
      :max-width="350"
      v-model="store.localeCode"
      :label="t('labels.language')"
      :items="settingsStore.languageOptions"
      v-on:update:model-value="onLanguageChange"
    ></PrimarySelect>
    -->
    <DataTable
      :editable="appStore.isProgramAdmin"
      :protected-item-ids="protectedItemIds"
      :confirm-mode="DialogConfirmMode.Revert"
      :delete-title="t('dialogs.headers.revertEmailTemplate')"
      :delete-message="t('dialogs.revert.emailTemplate')"
      :disable-delete-message="t('warnings.deleteDefaultEmailTemplate')"
      :table-store-id="TableStoreId.EmailTemplates"
      :show-new="false"
      :search-type="SearchType.Query"
    >
      <template v-slot:menuItems="{ item }">
        <v-list-item
          v-if="!appStore.isProgramAdmin"
          density="compact"
          :title="t('buttons.viewDetails')"
          prepend-icon="mdi-calendar-clock"
          @click="showEditDialog(item)"
        />
      </template>

      <template v-slot:item.type="{ item }">
        <v-chip
          v-tooltip="{
            openOnClick: true,
            text: t(`fields.emailTemplates.typeDescriptions.${getTypeCode(item.type)}`)
          }"
          :color="Colors.mainPrimary"
          size="small"
          density="compact"
          prepend-icon="mdi-information-slab-circle"
        >
          {{ t(`fields.emailTemplates.types.${getTypeCode(item.type)}`) }}
        </v-chip>
      </template>

      <template v-slot:footer>
        <EditEmailTemplate />
      </template>
    </DataTable>
  </v-container>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { DialogConfirmMode } from '@/enums/DialogConfirmMode'
import { EmailTemplateType } from '@/enums/EmailTemplateType'
import { SearchType } from '@/enums/SearchType'
// import { SqlComparison } from '@/enums/SqlComparison'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IEmailTemplatesStore } from '@/interfaces/api/IEmailTemplatesStore'
import type { EmailTemplateRecord } from '@/models/EmailTemplateRecord'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { useAppStore } from '@/stores/ui/AppStore'
// import { useSettingsStore } from '@/stores/ui/SettingsStore'
import Colors from '@/styles/_colors.module.scss'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const appStore = useAppStore()
// const settingsStore = useSettingsStore()
const store = TableStoreFactory.get(TableStoreId.EmailTemplates) as IEmailTemplatesStore
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const protectedItemIds = computed(() => {
  return store.items
    .filter((item) => {
      return item.isDefault
    })
    .map((item) => {
      return item.id
    })
})

// WATCHERS

// LIFECYCLE HOOKS

// FUNCTIONS
const getTypeCode = (type: string) => {
  switch (type) {
    case EmailTemplateType.FitTestCancelled:
    case EmailTemplateType.ClearanceCancelled:
    case EmailTemplateType.TrainingCancelled: {
      return 'cancelled'
    }
    case EmailTemplateType.FitTestDueSoon:
    case EmailTemplateType.ClearanceDueSoon:
    case EmailTemplateType.TrainingDueSoon: {
      return 'dueSoon'
    }
    case EmailTemplateType.FitTestModified:
    case EmailTemplateType.ClearanceModified:
    case EmailTemplateType.TrainingModified: {
      return 'modified'
    }
    case EmailTemplateType.FitTestOverdue:
    case EmailTemplateType.ClearanceOverdue:
    case EmailTemplateType.TrainingOverdue: {
      return 'overdue'
    }
    case EmailTemplateType.FitTestReminder:
    case EmailTemplateType.ClearanceReminder:
    case EmailTemplateType.TrainingReminder: {
      return 'reminder'
    }
    case EmailTemplateType.FitTestScheduled:
    case EmailTemplateType.ClearanceScheduled:
    case EmailTemplateType.TrainingScheduled: {
      return 'scheduled'
    }
    default:
      return type
  }
}

/**
const onLanguageChange = async () => {
  store.itemQuery = {
    where: [
      {
        field: 'locale',
        comparison: SqlComparison.Equal,
        value1: store.localeCode
      }
    ]
  }
  await store.loadItems()
}
 */

const showEditDialog = (item: EmailTemplateRecord) => {
  store.editItem(item)
  store.showEditDialog = true
}
</script>
